import SEO from '../components/SEO';
import ContactSection from '../sections/Contact';
import FAQSection from '../sections/FAQ';

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Our Web Development & AI Agency | Farwings Tech Solutions"
        description="Ready to build your next digital product? Contact Farwings Tech Solutions to discuss your web, mobile, or AI automation project today."
        keywords="Contact, Email, Farwings Solutions, Web Development Agency Contact"
        breadcrumbs={[
          { name: 'Home', path: '/' },
          { name: 'Contact', path: '/contact' },
        ]}
      />
      <ContactSection asPage />
      <FAQSection />
    </>
  );
}
